export default {
  clientId: '446144537611-pskmkt54i7jrh0ajf7gv5lv4vsklpjm8.apps.googleusercontent.com',
  scope: 'https://www.googleapis.com/auth/spreadsheets',
  spreadsheetId: '1OwMH_Z4ybcLIb3VwnYmT_sdHkNrUEeLDVVJdRzpT5NA'
}



/** WEBPACK FOOTER **
 ** ./src/config.js
 **/